import type { FC } from 'react'
import { useState, useEffect } from 'react'
import { Comment } from 'components/ui'
import type { Product } from 'framework/products'
import type { ProductCommentListProps } from '.'
import s from './product-comment-list.module.css'

const ProductCommentList: FC<ProductCommentListProps> = ({ productId }) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [comments, setComments] = useState<Product['comments']>([] as Product['comments'])

  useEffect(() => {}, [productId])

  if (comments!.length <= 0) {
    return null
  }

  return (
    <div className={s.root}>
      {comments!.map((comment) => (
        <Comment key={`product-comment-${comment.id}`} {...comment} />
      ))}
    </div>
  )
}

export default ProductCommentList
